import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b057ac34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-wrapper" }
const _hoisted_2 = ["onTouchstart", "onTouchend", "onClick"]

import { ref } from 'vue'
import { templateImageUrl } from '../definition'
import { clearToast, showToastFail, showToastSuccess, showToastLoading } from '@/utils/tools'
import { Overlay, ImagePreview, Toast } from 'vant'
import html2canvas from 'html2canvas'
import { showConfirmModal } from '@/utils/tools'
import { v4 as uuidv4 } from 'uuid'
import { isAndrod } from '@/utils/app'
import AppHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'certificate-template',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const showCertificateTemplate = ref(false)
function showTemplateImage() {
  showCertificateTemplate.value = true
}
function showTemplatePreview() {
  ImagePreview({
    images: [templateImageUrl],
    showIndex: false,
  })
}

const img = ref()
function saveImg() {
  showToastLoading({ message: '正在保存' })
  const Canvas = document.createElement('canvas')
  const width = document.body.offsetWidth // 可见屏幕的宽
  const height = document.body.offsetHeight // 可见屏幕的高
  const scale = window.devicePixelRatio // 设备的devicePixelRatio
  Canvas.width = width * scale
  Canvas.height = height * scale
  Canvas.getContext('2d').scale(scale, scale)
  html2canvas(img.value, {
    canvas: Canvas,
    scale,
    useCORS: true,
    logging: true,
    width: width,
    height: height,
  }).then((canvas) => {
    const context = canvas.getContext('2d')
    context.imageSmoothingEnabled = false
    // canvas转化为图片
    const src = canvas2Image(canvas, canvas.width, canvas.height)
    const a = document.createElement('a') // 生成一个a元素
    const event = new MouseEvent('click') // 创建一个单击事件
    const uuid = uuidv4()
    a.download = `${uuid}.png`
    a.href = src // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
    showToastSuccess('保存成功')
  })
}
function canvas2Image(canvas: HTMLCanvasElement, width: number, height: number) {
  const retCanvas = document.createElement('canvas')
  const retCtx = retCanvas.getContext('2d')
  retCanvas.width = width
  retCanvas.height = height
  retCtx.drawImage(canvas, 0, 0, width, height, 0, 0, width, height)
  const src = retCanvas.toDataURL('image/png') // 可以根据需要更改格式
  return src
}

function openImage(url: string) {
  AppHost.openBrowser(url)
}

const timer = ref(null)
function touchEnd() {
  clearTimeout(timer.value)
}
async function touchStart(e: Event) {
  clearTimeout(timer.value) //再次清空定时器，防止重复注册定时器
  console.log('isAndrod', isAndrod)
  if (!isAndrod) {
    // 非安卓app不处理
    return
  }
  timer.value = setTimeout(async () => {
    await showConfirmModal({ title: '是否保存图片？' })
    try {
      // saveImg()
      openImage(templateImageUrl)
    } catch (error) {
      console.log('error')
      showToastFail('保存失败')
    }
  }, 1000)
  e.preventDefault()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "upload-template-download",
      onClick: showTemplateImage
    }, "下载证明模板"),
    _createVNode(_unref(Overlay), {
      show: showCertificateTemplate.value,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showCertificateTemplate.value = false)),
      "z-index": "999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            ref_key: "img",
            ref: img,
            onTouchstart: _withModifiers(touchStart, ["stop"]),
            onTouchend: _withModifiers(touchEnd, ["stop"]),
            onClick: _withModifiers(showTemplatePreview, ["stop"]),
            class: "image",
            src: "https://static.knowledge.xag.cn/doc/device-replace/individual-payment-certificate.png"
          }, null, 40, _hoisted_2)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})